import { Injectable } from '@angular/core';
import {
  Router, Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { AuthService } from 'src/app/services/auth-service/auth.service';
import { LoaderService } from 'src/app/services/loader-service/loader.service';
import { ResultsService } from 'src/app/services/results-service/results.service';
import { eventCategories } from 'src/assets/data/categories';
import { ResultsResolverI } from '../results-home.component';

@Injectable({
  providedIn: 'root'
})
export class ResultsResolver implements Resolve<ResultsResolverI> {
  searchParams: { ena: string; dt: string; dist: string; t: string; cid: any; sw?: string; limit?: any; page?: any; start?: any, lid: string, results: any } = {
    ena: '',
    dt: '',
    dist: '',
    t: '',
    cid: '',
    sw: '',
    limit: null,
    page: null,
    start: null,
    lid: '214601',
    results: []
  };

  dropbox = {
    categories: [],
    names: [],
    dates: [],
    distances: [],
    types: []
  };

  resolveFunc: any;

  constructor(private resultService: ResultsService, private loaderService: LoaderService, private auth: AuthService) { 
    this.auth.getLidByToken().then((lid)=>{
      this.auth.lid = lid;
    })
  }

  resolve(): any {
    this.loaderService.show(5000);
      return this.getCategories().then(async () => {
        this.auth.getLidByToken().then((lid)=>{
          this.auth.lid = lid;
        })
        return await this.getCategories();
      })
  }

  //cat
  getCategories() {
    return this.resultService.getCategories(this.auth.lid).then(async c => {
      if(c.length>0){
        c.forEach((cat:any) => cat.name = eventCategories.find(e => e.id == cat.value)?.name);
        this.dropbox.categories = c;
        console.log('this.dropbox.categories: ', this.dropbox.categories);
        this.searchParams.cid = c[0].value || "-1";
        return await this.getEventNames(c[0].value);
      }else{
        return await []
      }
    });
  }

  // ena
  getEventNames(cid: any) {
    return this.resultService.getEventNames(this.auth.lid, cid).then(async n => {
      if(n.length>0){
        this.dropbox.names = n;
        this.searchParams.ena = n[0].value || "-1";
        return await this.getEventDates(n[0].value);
      }else{
        return await ''
      }
    });
  }

  // dt
  getEventDates(ena: string) {
    return this.resultService.getEventDates(ena, this.searchParams.cid, this.auth.lid).then(async d => {
      if(d.length>0){
        this.dropbox.dates = d;
        this.searchParams.dt = d[0].value || "-1";
        return await this.getEventDistances(ena, d[0].value);
      }else{
        return await ''
      }
    });
  }

  // dist
  getEventDistances(ena: string, date: string) {
    return this.resultService.getEventDistances(ena, date, this.searchParams.cid, this.auth.lid).then(async d => {
      this.dropbox.distances = d;
      this.searchParams.dist = d[0].value || "-1";
      return await this.getEventTypes(ena, date, d[0].value)
    });
  }

  // t
  getEventTypes(ena: string, date: string, dist: string) {
    return this.resultService.getEventTypes(ena, date, dist, this.searchParams.cid, this.auth.lid).then(async t => {
      this.dropbox.types = t;
      this.searchParams.t = t[0].value || "-1";
      this.searchParams.page = null;
      this.searchParams.start = null;
      this.searchParams.limit = null;
      return await this.getResults();
    });
  }

  // results
  getResults() {
    this.auth.getLidByToken().then(lid=>{
      this.searchParams.lid = lid;
      return this.resultService.getResults(this.searchParams).then(r => {
        this.searchParams.results = r;
        return { searchParams: this.searchParams, dropbox: this.dropbox };
      });
    })
  }
}
